var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 161") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.78,
    strokeOpacity: 0.78
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Logga-in-Copy-8",
    transform: "translate(-1312.000000, -886.000000)",
    fill: "#000000",
    stroke: "#000000",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1313.26626,896.227852 C1313.09727,896.057214 1313.00121,895.824635 1312.99999,895.581733 C1312.99884,895.338831 1313.09252,895.105037 1313.26033,894.933184 L1320.74647,887.266585 C1320.92021,887.088659 1321.1479,887 1321.3756,887 C1321.6033,887 1321.83099,887.088659 1322.00473,887.266585 C1322.35161,887.622437 1322.35161,888.199329 1322.00473,888.554574 L1316.05496,894.647774 L1332.11057,894.647774 C1332.60213,894.647774 1333.00001,895.05585 1333.00001,895.558657 C1333.00001,896.062072 1332.60213,896.46954 1332.11057,896.46954 L1316.04725,896.46954 L1321.98635,902.43886 C1322.33738,902.791676 1322.34213,903.367961 1321.99821,903.727456 C1321.6537,904.086344 1321.09038,904.091202 1320.74054,903.739601 L1313.26626,896.227852 Z",
    id: "Fill-161"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.b6b46a0c2a9a46c66b573f61adc50011.svg";
export { ForwardRef as ReactComponent };